
import formMixin from '~/services/form';
import { email, min, required } from '~/services/validators';

export default {
    name: 'BusinessEmployeesInvite',
    mixins: [formMixin],
    middleware: 'auth',
    props: {
        /**
         * An Organisation object
         */
        organisation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            email: '',
        };
    },
    methods: {
        submit() {
            this.$form
                .submit(`${this.$config.endpoints.organisation}/${this.organisation.slug}/invite`, '$put', {
                    email: this.email,
                })
                .then(({ message }) => {
                    this.$store.dispatch('setFlashMessage', { message });
                    this.$emit('invited');
                });
        },
    },
    validations: {
        email: [email, { validator: min, length: 5 }, required],
    },
};
